import { useEffect, useState } from 'react';
import { FaChartLine, FaDraftingCompass, FaMapMarkedAlt } from 'react-icons/fa';
import SectionHeader from './SectionHeader.jsx';

const modelItems = [
  {
    id: 'land',
    title: 'Land Owner',
    label: 'Land owner',
    summary: 'Unlock the true potential of your land through research, strategy, and the right development partnerships.',
    nodeClass: 'top',
    Icon: FaMapMarkedAlt,
  },
  {
    id: 'investor',
    title: 'Investor',
    label: 'Investor',
    summary: 'Access opportunities with clearer fundamentals, aligned timelines, and better visibility into where capital performs best.',
    nodeClass: 'right',
    Icon: FaChartLine,
  },
  {
    id: 'developer',
    title: 'Developer',
    label: 'Developer',
    summary: 'Design stronger projects with sharper demand intelligence, better planning inputs, and more confident execution.',
    nodeClass: 'left',
    Icon: FaDraftingCompass,
  },
];

const AUTO_ROTATE_MS = 7000;

function getNextOrbitStep(currentStep, targetIndex) {
  const currentIndex = currentStep % modelItems.length;
  const forwardSteps = (targetIndex - currentIndex + modelItems.length) % modelItems.length;

  return currentStep + forwardSteps;
}

function ModelBadge({ item }) {
  const BadgeIcon = item.Icon;

  return (
    <div className={`model-card-icon model-card-icon--${item.id}`} aria-hidden="true">
      <BadgeIcon />
    </div>
  );
}

function ModelSection() {
  const [orbitStep, setOrbitStep] = useState(0);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    if (hoveredIndex !== null) {
      return undefined;
    }

    const timerId = window.setInterval(() => {
      setOrbitStep((currentStep) => currentStep + 1);
    }, AUTO_ROTATE_MS);

    return () => window.clearInterval(timerId);
  }, [hoveredIndex]);

  const currentIndex = orbitStep % modelItems.length;
  // const activeItem = modelItems[currentIndex];
 const orbitAngle = orbitStep * 120;

  const activeItem = modelItems[currentIndex];

  // const activateItem = (targetIndex) => {
  //   setOrbitStep((currentStep) => getNextOrbitStep(currentStep, targetIndex));
  // };

const activateItem = (targetIndex) => {
  setOrbitStep((currentStep) =>
    getNextOrbitStep(currentStep, targetIndex)
  );
};

  return (
    <section id="model" data-section className="section-model fade-up">
      <div className="section-wrap">
        <SectionHeader
          title="The Trikon Model"
          subtitle="A balanced ecosystem connecting Land, Development, and Capital - designed for aligned growth and smarter outcomes."
        />

        <div className="tri-connector">
          <div className="tc-line"></div>
          <div className="tc-diamond connector-spacer"></div>
          <div className="tc-line connector-short"></div>
          <div className="tc-tri">
            <svg width="20" height="18" viewBox="0 0 20 18" fill="none" aria-hidden="true">
              <polygon
                points="10,1 19,17 1,17"
                stroke="#00d4c8"
                strokeWidth="1.5"
                fill="rgba(0,212,200,.12)"
              />
            </svg>
          </div>
          <div className="tc-line connector-short"></div>
          <div className="tc-diamond connector-spacer"></div>
          <div className="tc-line"></div>
        </div>

        <div className="model-reference-layout">
          <div className="model-reference-visual">
            <div
              className={`model-diagram model-diagram--${activeItem.id}`}
              style={{ '--orbit-angle': `${orbitAngle}deg` }}
              aria-label="Trikon model diagram"
            >
              <div className="model-diagram-ring model-diagram-ring--outer" aria-hidden="true"></div>
              <div className="model-diagram-ring model-diagram-ring--inner" aria-hidden="true"></div>

              <svg className="model-reference-triangle" viewBox="0 0 320 320" fill="none" aria-hidden="true">
                <path d="M160 72L240 210H80L160 72Z" className="model-reference-triangle-shape" />
                <path d="M160 72V160" className="model-reference-triangle-line" />
                <path d="M80 210L160 160" className="model-reference-triangle-line" />
                <path d="M240 210L160 160" className="model-reference-triangle-line" />
              </svg>

             <div className="model-reference-core">
  <span>
    Trikon <br />
    Ecosystem
  </span>
</div>

              {modelItems.map((item, index) => {
                const isActive = currentIndex === index;

                return (
                  <button
                    key={item.id}
                    type="button"
                    className={`model-reference-node model-reference-node--${item.nodeClass} ${isActive ? 'is-active' : ''}`}
                    onMouseEnter={() => {
                      activateItem(index);
                    
                    }}
                   
                    onFocus={() => {
                      activateItem(index);
                     
                    }}
                  
                    onClick={() => activateItem(index)}
                  >
                    <span>{item.label}</span>
                  </button>
                );
              })}

              <div className="model-reference-orb-track" aria-hidden="true">
                <div className="model-reference-orb"></div>
              </div>
            </div>
          </div>

          <div className={`model-reference-card model-reference-card--${activeItem.id}`}>
            <div className="model-card-badge">
              <div className="model-card-badge-glow"></div>
              <ModelBadge item={activeItem} />
            </div>

            <div className="model-card-body">
              <h3 className="model-card-heading">{activeItem.title}</h3>
              <p className="model-card-copy">{activeItem.summary}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ModelSection;
